import { render, staticRenderFns } from "./QType6Answer.vue?vue&type=template&id=69ac8640&scoped=true&"
import script from "./QType6Answer.vue?vue&type=script&lang=js&"
export * from "./QType6Answer.vue?vue&type=script&lang=js&"
import style0 from "./QType6Answer.vue?vue&type=style&index=0&id=69ac8640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ac8640",
  null
  
)

export default component.exports